import { Component, inject, OnInit } from '@angular/core';
import { AbstractSelectionService } from 'gung-list';
import { AuthService, ProductListComponent, ProductSelectionService } from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'colmec-product-list',
  template: '<colmec-filter-list #productList [configService]="productListConfigService"></colmec-filter-list>',
  styleUrls: ['./colmec-product-list.component.scss'],
  providers: [
    {
      provide: AbstractSelectionService,
      useClass: ProductSelectionService
    }
  ],
  standalone: false
})
export class ColmecProductListComponent extends ProductListComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const assortmentId = params.get('assortmentId');

      if (assortmentId != null) {
        this.productListConfigService.assortmentSubject.next(assortmentId);
      } else {
        this.authService
          .getCurrentUser()
          .pipe(first())
          .subscribe(user => this.productListConfigService.assortmentSubject.next(user.assortment));
      }
    });
  }
}
